
import React from "react";
import { Link } from "react-router-dom";

interface SidebarLogoProps {
  isCollapsed?: boolean;
  onLinkClick?: () => void;
}

const SidebarLogo: React.FC<SidebarLogoProps> = ({ isCollapsed = false, onLinkClick }) => {
  return (
    <Link 
      to="/" 
      onClick={onLinkClick}
      className={`flex items-center ${isCollapsed ? "justify-center px-4" : "gap-[13px] px-8"} py-[29px]`}
    >
      <div className="text-sidebar-foreground">
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="16"
            cy="16"
            r="14.5"
            stroke="currentColor"
            strokeWidth="3"
          ></circle>
          <mask id="path-2-inside-1_102_2292" fill="white">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M7 16.195C8.79648 13.0894 12.1542 11 16 11C19.8458 11 23.2035 13.0894 25 16.195C23.2035 19.3006 19.8458 21.39 16 21.39C12.1542 21.39 8.79648 19.3006 7 16.195Z"
            ></path>
          </mask>
          <path
            d="M7 16.195L5.26879 15.1935L4.68948 16.195L5.26879 17.1965L7 16.195ZM25 16.195L26.7312 17.1965L27.3105 16.195L26.7312 15.1936L25 16.195ZM8.73121 17.1965C10.1849 14.6835 12.897 13 16 13V9C11.4114 9 7.40806 11.4954 5.26879 15.1935L8.73121 17.1965ZM16 13C19.103 13 21.8151 14.6835 23.2688 17.1965L26.7312 15.1936C24.5919 11.4954 20.5886 9 16 9V13ZM23.2688 15.1936C21.8151 17.7065 19.103 19.39 16 19.39V23.39C20.5886 23.39 24.5919 20.8946 26.7312 17.1965L23.2688 15.1936ZM16 19.39C12.897 19.39 10.1849 17.7065 8.73121 15.1935L5.26879 17.1965C7.40806 20.8946 11.4114 23.39 16 23.39V19.39Z"
            fill="currentColor"
            mask="url(#path-2-inside-1_102_2292)"
          ></path>
          <circle
            cx="16"
            cy="16.1951"
            r="3"
            stroke="currentColor"
            strokeWidth="2"
          ></circle>
          <path
            d="M3.87564 23L16 2L28.1244 23H3.87564Z"
            stroke="currentColor"
            strokeWidth="2"
          ></path>
        </svg>
      </div>
      {!isCollapsed && (
        <div className="text-sidebar-foreground text-2xl font-normal">remoteviz</div>
      )}
    </Link>
  );
};

export default SidebarLogo;
